import { fixHref, formatText, youtubeIdRegex } from '../utils';
import { getTemplateSocialCardAsset } from '../Template/socialCard'; // take an item downloaded from the CMS and convert it to a search hit
// returns null if the content is invalid

function filterUntranslatedSearchHits(item) {
  return item.translated === false || item.translated === undefined;
}

export function itemToSearchHit(item) {
  var _item$videoUrl, _item$featuredVideo, _item$title, _item$description, _item$title2, _item$introduction, _item$label, _item$name, _item$body, _item$description2, _item$videoDuration, _item$label2, _item$question, _item$category, _item$category$name, _item$categories, _item$categories$, _item$categories$$nam, _item$title3, _item$label3, _item$title4, _item$description3, _item$label4;

  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  if (item.isSearchHit) {
    return item;
  }

  if (locale !== 'en' && filterUntranslatedSearchHits(item)) {
    return null;
  }

  var ctype = item.contentType;

  if (!ctype || !item.id || !(item.urlSlug || item.url) || Date.parse(item.releaseDate) > Date.now()) {
    return null;
  }

  var doc = {
    contentType: ctype,
    id: item.id,
    urlSlug: item.urlSlug,
    isSearchHit: true
  };
  var videoUrlParsed = youtubeIdRegex.exec((_item$videoUrl = item.videoUrl) === null || _item$videoUrl === void 0 ? void 0 : _item$videoUrl.trim());
  var blogVideoUrlParsed = youtubeIdRegex.exec((_item$featuredVideo = item.featuredVideo) === null || _item$featuredVideo === void 0 ? void 0 : _item$featuredVideo.trim());

  switch (ctype) {
    case 'event':
      doc.title = (_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title.trim();
      doc.description = formatText((_item$description = item.description) === null || _item$description === void 0 ? void 0 : _item$description.trim());
      doc.image = item.image; // TODO: fallback image based on franchise

      doc.date = item.date;
      doc.label = item.franchise;
      doc.location = item.location;
      doc.linkExternal = true;
      break;

    case 'blogPost':
      doc.title = (_item$title2 = item.title) === null || _item$title2 === void 0 ? void 0 : _item$title2.trim();
      doc.description = (_item$introduction = item.introduction) === null || _item$introduction === void 0 ? void 0 : _item$introduction.trim();
      doc.image = item.featuredImage;
      doc.videoUrl = blogVideoUrlParsed && blogVideoUrlParsed[1] || undefined;
      doc.label = (_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.trim();
      doc.date = item.releaseDate;
      break;

    case 'video':
      doc.title = (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.trim();
      doc.description = ((_item$body = item.body) === null || _item$body === void 0 ? void 0 : _item$body.trim()) || ((_item$description2 = item.description) === null || _item$description2 === void 0 ? void 0 : _item$description2.trim());
      doc.duration = (_item$videoDuration = item.videoDuration) === null || _item$videoDuration === void 0 ? void 0 : _item$videoDuration.trim();
      doc.videoUrl = videoUrlParsed && videoUrlParsed[1] || undefined;
      doc.image = item.thumbnailImage;
      doc.label = (_item$label2 = item.label) === null || _item$label2 === void 0 ? void 0 : _item$label2.trim();
      doc.date = item.releaseDate;
      break;

    case 'faq':
      doc.title = (_item$question = item.question) === null || _item$question === void 0 ? void 0 : _item$question.trim();
      doc.label = ((_item$category = item.category) === null || _item$category === void 0 ? void 0 : (_item$category$name = _item$category.name) === null || _item$category$name === void 0 ? void 0 : _item$category$name.trim()) || ((_item$categories = item.categories) === null || _item$categories === void 0 ? void 0 : (_item$categories$ = _item$categories[0]) === null || _item$categories$ === void 0 ? void 0 : (_item$categories$$nam = _item$categories$.name) === null || _item$categories$$nam === void 0 ? void 0 : _item$categories$$nam.trim()) || undefined;
      break;

    case 'guideSection':
    case 'guidePage':
      doc.title = (_item$title3 = item.title) === null || _item$title3 === void 0 ? void 0 : _item$title3.trim();
      doc.label = ((_item$label3 = item.label) === null || _item$label3 === void 0 ? void 0 : _item$label3.trim()) || 'Guide';
      break;

    case 'landingPage':
    case 'videoPage':
    case 'articlePage':
      doc.title = (_item$title4 = item.title) === null || _item$title4 === void 0 ? void 0 : _item$title4.trim();
      doc.description = (_item$description3 = item.description) === null || _item$description3 === void 0 ? void 0 : _item$description3.trim();
      doc.label = (_item$label4 = item.label) === null || _item$label4 === void 0 ? void 0 : _item$label4.trim();
      doc.image = getTemplateSocialCardAsset(item);
      break;

    default:
      break;
  }

  doc.url = getLinkForSearchHit(item);
  return doc.title ? doc : null;
}
export function getLinkForSearchHit(doc) {
  var ctype = doc.contentType;

  if (ctype === 'blogPost') {
    return "/blog/".concat(doc.urlSlug);
  }

  if (ctype === 'video') {
    return "/videos/all-videos/".concat(doc.urlSlug);
  }

  if (ctype === 'videoPage') {
    return "/video/".concat(doc.urlSlug);
  }

  if (ctype === 'faq') {
    return "/help/article/".concat(doc.urlSlug);
  }

  if (ctype === 'landingPage') {
    return "/".concat(doc.urlSlug);
  }

  if (ctype === 'articlePage') {
    return "/blog/".concat(doc.urlSlug);
  }

  if (ctype === 'event') {
    return fixHref(doc.url) || '/';
  }

  return '/';
}